import { tenantLocationsService } from '@/services/tenant-locations.service';

const initialState = () => ({
  tenantLocations: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getTenantLocations({ commit }) {
    commit('GET_TENANT_LOCATIONS');
    return tenantLocationsService.getTenantLocations().then(
      (tenantLocations) => {
        commit('SUCCESS', tenantLocations);
        return tenantLocations;
      },
      (error) => {
        commit('ERROR', error.response);
        throw error;
      },
    );
  },

  addTenantLocation({ commit }, locationData) {
    return tenantLocationsService.addTenantLocation(locationData).then(
      (newLocation) => {
        commit('ADD_LOCATION_SUCCESS', newLocation);
        return newLocation;
      },
      (error) => {
        commit('ERROR', error.response);
        throw error;
      },
    );
  },

  editTenantLocation({ commit }, { locationId, updatedData }) {
    commit('GET_TENANT_LOCATIONS');
    return tenantLocationsService.editTenantLocation(locationId, updatedData).then(
      (updatedLocation) => {
        commit('EDIT_LOCATION_SUCCESS', updatedLocation);
        return updatedLocation;
      },
      (error) => {
        commit('ERROR', error.response);
        throw error;
      },
    );
  },

  deleteTenantLocation({ commit }, locationId) {
    commit('GET_TENANT_LOCATIONS');
    return tenantLocationsService.deleteTenantLocation(locationId).then(
      () => {
        commit('DELETE_LOCATION_SUCCESS', locationId);
      },
      (error) => {
        commit('ERROR', error.response);
        throw error;
      },
    );
  },
};

const mutations = {
  GET_TENANT_LOCATIONS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },

  SUCCESS(state, tenantLocations) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.tenantLocations = tenantLocations;
  },

  ADD_LOCATION_SUCCESS(state, newLocation) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.tenantLocations.push(newLocation);
  },

  EDIT_LOCATION_SUCCESS(state, updatedLocation) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    const index = state.tenantLocations.findIndex((location) => location.id === updatedLocation.id);
    if (index !== -1) {
      state.tenantLocations.splice(index, 1, updatedLocation);
    }
  },

  DELETE_LOCATION_SUCCESS(state, locationId) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.tenantLocations = state.tenantLocations.filter((location) => location.id !== locationId);
  },

  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  tenantLocations: (state) => state.tenantLocations,
  // Status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const tenantLocations = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
